"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var semverGte = require('semver/functions/gte');
var ContractVersion = /** @class */ (function () {
    function ContractVersion(storage, major, minor, patch) {
        var _this = this;
        this.storage = storage;
        this.major = major;
        this.minor = minor;
        this.patch = patch;
        this.toSemver = function () { return _this.storage + "." + _this.major + "." + _this.minor; };
        this.isAtLeast = function (other) { return semverGte(_this.toSemver(), other.toSemver()); };
        this.toString = function () { return _this.toSemver().concat("." + _this.patch); };
        this.toRaw = function () { return [_this.storage, _this.major, _this.minor, _this.patch]; };
    }
    ContractVersion.fromRaw = function (raw) {
        return new ContractVersion(raw[0], raw[1], raw[2], raw[3]);
    };
    return ContractVersion;
}());
exports.ContractVersion = ContractVersion;
exports.newContractVersion = function (storage, major, minor, patch) {
    return new ContractVersion(storage, major, minor, patch);
};
//# sourceMappingURL=versions.js.map